export default "__VITE_ASSET__fb6d8b7f__"